@if (connectionCode$ | async) {
  <div class="flex flex-col gap-4 text-center">
    <span class="text-5xl">
      {{ connectionCode$ | async }}
    </span>
    @if ((connectionCodeTtl$ | async)! > 0 || (connectionCodeTtl$ | async) === null) {
      <p class="text-zaeper-gray-200">
        Verbindungscode ist noch {{ (connectionCodeTtl$ | async) || 0 }} Sekunden verfügbar.
      </p>
      <p-button
        (onClick)="openQrCodeModal()"
        label="Code anzeigen"
        [rounded]="true"
        icon="pi pi-qrcode"
      ></p-button>
    } @else {
      <p class="text-zaeper-error-500">
        Verbindungscode ist abgelaufen.
      </p>
      <p-button
        (onClick)="requestNewConnectionCode()"
        [label]="'regenerate-connection-code' | zDictionary"
        [rounded]="true"
        icon="pi pi-refresh"
      ></p-button>
    }
  </div>
} @else {
  <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
}

